export default __webpack_public_path__ + "static/media/icon-ellipsis-vertical.d0ab50fc.svg";